import API from "./http/axios";

class ApiService {
  static async get(endpoint, config = {}) {
    return await API.get(endpoint, config);
  }

  static async post(endpoint, payload = {}, config = {}) {
    return await API.post(endpoint, payload, config);
  }

  static async put(endpoint, payload = {}, config = {}) {
    return await API.put(endpoint, payload, config);
  }

  static async patch(endpoint, payload = {}, config = {}) {
    return await API.patch(endpoint, payload, config);
  }

  static async delete(endpoint, config = {}) {
    return await API.delete(endpoint, config);
  }

  static async getResultDetails(resultId) {
    return await this.get(`/results/${resultId}/details`);
  }

  static async getResults() {
    return await this.get("/results");
  }
}

export default ApiService;
